// extracted by mini-css-extract-plugin
module.exports = {"component":"select_component__-KPzf","option":"select_option__3Fj0p","flag":"select_flag__oD060","countryName":"select_countryName__1eleH","dialCode":"select_dialCode__3A9sm"};